import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdDocument } from "react-icons/io";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  requestProjectsById,
  setResetStateProjectsById,
} from "../../../Redux/ProjectState/ProjectActionCreator";
import { getValuesFromLocalstorage } from "../../../components/Helpers";
import {
  requestAddTimesheet,
  requestEditTimesheets,
  requestGetTimesheetById,
  requestTimesheetById,
  requestTimesheetsByIdForUserPage,
  responseGetTimesheetById,
  setResetAddTimesheet,
  setResetEditTimesheets,
  setResetGetTimesheetById,
  setResetStateTimesheetById,
  setResetStateTimesheetsByIdForUserPage,
} from "../../../Redux/TimeSheetState/TimeSheetActionCreator";
import TimeSheet from "../../Employee/TimeSheet";
import CustomDataTable from "../../../components/CustomDataTable";
import Loader from "../../../components/Loader";
import CustomDropdown from "../../../components/CustomDropdown";
import { MdCancel, MdEdit, MdPending } from "react-icons/md";
import { FcApproval, FcCancel } from "react-icons/fc";
import CustomToolTip from "../../../components/ToolTip";
import moment from "moment";
import Hoc from "../../../components/HOC";

const EmployeeDashboard = () => {
  const navigate = useNavigate();
  const userDetails = getValuesFromLocalstorage("userDetails");
  const [selectedOption, setSelectedOption] = useState(null);
  // const [initialValues, setInitialValues] = useState({
  //   projectId: "",
  //   work_location: "",
  //   startDate: "",
  //   endDate: "",
  //   total_hours: null,
  //   holidays: null,
  // });

  const [isModalOpen, setIsModalOpen] = useState({ title: "", isOpen: false });
  const projectsList = useSelector((state) => state.ProjectsByIdReducer);
  const TimeSheets = useSelector(
    (state) => state.TimeSheetByProjectIdReducerForUserPage
  );
  const AddTimeSheetSate = useSelector((state) => state.AddTimesheetReducer);
  const timesheetByIdReducer = useSelector(
    (state) => state.GetTimesheetByIdReducer
  );
  const editTimesheetReducer = useSelector(
    (state) => state.EditTimesheetsReducer
  );

  const dispatch = useDispatch();
  const conditionalRowStyles = [
    {
      when: (row) => row.status === "APP",
      style: {
        backgroundColor: "#E0FFE0",
        color: "black",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#E0FFE0",
          color: "#black",
        },
      },
    },
    // {
    //   when: row => row.status === "SUB",
    //   style: {
    //     backgroundColor: 'rgba(248, 148, 6, 0.9)',
    //     color: 'white',
    //     '&:hover': {
    //       cursor: 'pointer',
    //     },
    //   },
    // },
    {
      when: (row) => row.status === "REJ",
      style: {
        backgroundColor: "#FF85A2",
        color: "black",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#FF85A2",
          color: "#black",
        },
      },
    },
  ];

  const columns = [
    {
      name: "Start Date",
      selector: (row) => moment(row.startDate).format("MM-DD-YYYY"),
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => moment(row.endDate).format("MM-DD-YYYY"),
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.work_location,
      sortable: true,
      hide: "sm",
    },
    {
      name: "Total Hours",
      selector: (row) => row.total_hours,
      sortable: true,
      hide: "sm",
    },
    {
      name: "Status",
      selector: (row) =>
        (row.status === "SUB" && (
          <>
            <MdPending size={24} data-tip data-for="submitted" />
            <CustomToolTip id="submitted" title="Submitted" />
          </>
        )) ||
        (row.status === "APP" && (
          <>
            <FcApproval size={24} data-tip data-for="approved" />
            <CustomToolTip id="approved" title="Approved" />
          </>
        )) ||
        (row.status === "REJ" && (
          <>
           <MdCancel size={24} fill="red" data-tip data-for="rejected" />
            <CustomToolTip id="rejected" title="Rejected" />
          </>
        )) ||
        row.status,
      sortable: true,
      hide: "sm",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-2">
          

          <div className="lg:hidden">
            {row.status === "APP" && (
              <span className="text-green-500 text-[12px]">Approved</span>
            )}
            {row.status === "REJ" && (
              <span className="text-red-500 text-[12px]">Rejected</span>
            )}
            {row.status === "SUB" && (
              <span className="text-yellow-500 text-[10px]">Submitted</span>
            )}
          </div>
          <button
            disabled={row.status === "APP"}
            onClick={() => handleEdit(row)}
            className={`text-primary hover:text-primaryDark disabled:cursor-not-allowed
            ${(row.status === "APP" ? "hidden sm:block" : "block sm:hidden")}
            ${(row.status === "REJ" || row.status === "SUB"  ? "block lg:block" : "")}
            `}
          > 
            <MdEdit size={24} className={row.status === "APP" ? "text-gray-300" : "text-primary"}  />
          </button>
        </div>
      ),
    },
  ];

  const handleClose = () => {
    setIsModalOpen({ title: "", isOpen: false });
    dispatch(setResetEditTimesheets());
    dispatch(setResetStateTimesheetById());
  };

  const handleEdit = (row) => {
    dispatch(setResetGetTimesheetById());
    setIsModalOpen({ title: "", isOpen: false });
    let isProjectEnded = row?.endDate && moment().isAfter(moment(row?.endDate));
    dispatch(requestGetTimesheetById(row.id));
    setIsModalOpen({ title: "Edit TimeSheet", isOpen: true });
    // if(isProjectEnded){
    //   toast.warn("This project has ended. You cannot enter a timesheet.")
    // } else {
    //   dispatch(requestGetTimesheetById(row.id));
    //   setIsModalOpen({ title: "Edit TimeSheet", isOpen: true });
    // }
  };

  const handleAddTimeSheet = (values, selectedFile) => {
    console.log(values,"his")
    if (isModalOpen.title === "Add TimeSheet") {
      const holidays = Object.values(values.holidays).map((holiday) => ({
        // [holiday.date]: holiday.notes,
        employee_holiday_date: holiday.date,
        notes: holiday.notes,
      }));
      const holidaysObject = Object.assign({}, ...holidays);

      const timeSheetPayload = {
        ...values,
      };
      dispatch(
        requestAddTimesheet({
          timeSheets: JSON.stringify([timeSheetPayload]),
          files: selectedFile || "null",
        })
      );
    } else {
      
      const editTimeSheetPayload = {
        
          // projectId: values.projectId,
          work_location: values.work_location,
          startDate: values.startDate,
          endDate: values.endDate,
          total_hours: values.total_hours,
          holidays: values.holidays,
          // remarks: values.rejectionRemarks || null, 
      };
      dispatch(
        requestEditTimesheets({
          id: timesheetByIdReducer?.Response?.id,
          // data: values,
          timeSheet: JSON.stringify(editTimeSheetPayload), // Stringify the data here
          files: selectedFile || "null",
        })
      );
    }
  };

  useEffect(() => {
    if (projectsList?.error && !projectsList?.loading) {
      // toast.error("No Projects found");
      dispatch(setResetStateProjectsById());
    }
    if (!selectedOption && projectsList?.response?.length > 0) {
      setSelectedOption(projectsList.response[0]); // Set first project as default
    }
  }, [projectsList]);

  useEffect(() => {
    if (!timesheetByIdReducer?.Loading && timesheetByIdReducer?.Response) {
      setIsModalOpen({ title: "Edit Timesheet", isOpen: true });
    } else if (!timesheetByIdReducer?.Loading && timesheetByIdReducer?.Error) {
      toast.error("Error fetching Timesheet data");
      dispatch(setResetGetTimesheetById());
    }
  }, [timesheetByIdReducer]);

  useEffect(() => {
    if (!editTimesheetReducer?.Loading && editTimesheetReducer?.Response) {
      const updatedTimesheet = editTimesheetReducer.Response;
      const updatedData = TimeSheets.response.content.map((item) =>
        item.id === updatedTimesheet.id
          ? { ...updatedTimesheet, status: "SUB" }
          : item
      );

      dispatch(
        requestTimesheetsByIdForUserPage({
          project: selectedOption,
          page: TimeSheets?.page,
          size: TimeSheets?.size,
          content: updatedData,
        })
      ); 

      toast.success("Timesheet updated successfully");
      handleClose();
      dispatch(setResetEditTimesheets());
    } else if (!editTimesheetReducer?.Loading && editTimesheetReducer?.Error) {
      toast.error("Error updating Timesheet");
      dispatch(setResetEditTimesheets());
    }
  }, [editTimesheetReducer, TimeSheets, selectedOption]);

  useEffect(() => {
    if (AddTimeSheetSate.response && !AddTimeSheetSate.loading) {
      toast.success(AddTimeSheetSate.response);
      setIsModalOpen({ title: "", isOpen: false });
      if (TimeSheets?.initialValues.projectId) {
        dispatch(
          requestTimesheetsByIdForUserPage({
            project: TimeSheets?.initialValues.projectId,
            page: 0,
            size: 10,
          })
        );
      }
      dispatch(setResetAddTimesheet());
    } else if (AddTimeSheetSate.error && !AddTimeSheetSate.loading) {
      toast.error("Error adding Timesheet");
      dispatch(setResetAddTimesheet());
    }
  }, [AddTimeSheetSate]);

  useEffect(() => {
    dispatch(requestProjectsById());
    dispatch(
      setResetStateTimesheetsByIdForUserPage({
        page: TimeSheets?.page,
        size: TimeSheets?.size,
      })
    );
    // dispatch(requestTimesheetsByIdForUserPage({ page: TimeSheets?.page, size: TimeSheets?.size }))
    dispatch(setResetAddTimesheet());
    dispatch(setResetEditTimesheets());
    dispatch(setResetGetTimesheetById());
  }, []);

  useEffect(() => {
    // if (selectedOption) {
    //   setInitialValues((prevValues) => ({
    //     ...prevValues,
    //     projectId: selectedOption?.id, 
    //   }));
  
      dispatch(setResetStateTimesheetsByIdForUserPage());
      dispatch(
        requestTimesheetsByIdForUserPage({
          project: selectedOption,
          page: TimeSheets.page,
          size: TimeSheets.size,
        })
      );
    // }
  }, [selectedOption]);
 

  useEffect(() => {
    if (TimeSheets?.error && !TimeSheets?.loading ) {
      // toast.error("No timesheet found / something went wrong");
      dispatch(setResetStateTimesheetsByIdForUserPage());
    }
  }, [TimeSheets]);

  const handlePageChange = (page) => {
    dispatch(
      requestTimesheetsByIdForUserPage({
        project: selectedOption,
        page: page,
        size: TimeSheets?.size,
      })
    );
  };

  const handleRowsChange = (size) => {
    dispatch(
      requestTimesheetsByIdForUserPage({
        project: selectedOption,
        page: 0,
        size: size,
      })
    );
  };

  // const selectedProject = projectsList?.response?.find(
  //   (project) => project.id === selectedOption
  // );

  // const projectEndDate = selectedProject
  //   ? moment(selectedProject.endDate)
  //   : null;

  // const isProjectExpired =
  // projectEndDate && projectEndDate.isBefore(moment(), "day");
  const isProjectExpired = moment(
    TimeSheets?.selectedProject?.endDate
  ).isBefore(moment(), "day");

  return (
    <div className="w-full p-3 h-[85vh] overflow-y-scroll">
      <Loader
        isLoading={
          TimeSheets?.loading ||
          projectsList?.loading ||
          timesheetByIdReducer?.Loading
        }
      />

      <div className=" flex justify-between items-center mb-4 z-10 mr-2 gap-4 right-6">
       <div className="lg:w-1/4 md:w-1/2 w-full">
       <CustomDropdown
            // value={
            //   projectsList?.response?.find(
            //     (project) => project?.id === selectedOption?.id
            //   ) || null
            // }
            value = {selectedOption}
            customClasses="w-76 text-left"
            name="project"
            handleChange={(selectedOption) => {
              setSelectedOption(selectedOption);
            }}
            placeholder="Select Project"
            options={projectsList?.response || []}
            handleGetOptionValue={(option) => option.id}
            handleGetOptionName={(option) => option.projectName}
          />
        </div>

        <button
           onClick={() =>
            setIsModalOpen({ title: "Add TimeSheet", isOpen: true })
          }
          className="flex items-center justify-center bg-primary hover:bg-primaryDark text-white py-1 px-6 mr-4  rounded-full shadow-lg transition-all duration-300"
        >
          <span className="text-2xl font-medium">+</span>
        </button>
   </div>
      <TimeSheet
        timesheetValues={
          isModalOpen.title === "Add TimeSheet"
            ? TimeSheets?.initialValues
            : {
                ...timesheetByIdReducer.Response,
                projectId: timesheetByIdReducer.Response?.projectId || "",
                rejectionRemarks:
                  timesheetByIdReducer.Response?.status === "REJ"
                    ? timesheetByIdReducer.Response?.remarks
                    : "",
              }
        }
        show={isModalOpen.isOpen}
        onClose={handleClose}
        title={isModalOpen.title}
        onAddTimeSheet={handleAddTimeSheet}
        projectsList={projectsList?.response || []}
        minDate={TimeSheets?.initialValues.startDate} // Pass Min Date
        maxDate={TimeSheets?.initialValues.endDate}
      />
      <CustomDataTable
        columns={columns}
        data={TimeSheets?.response?.content || []}
        fixedHeaderScrollHeight="60vh"
        enableSearch={false}
        serverPagenation
        conditionalRowStyles={conditionalRowStyles}
        paginationTotalRows={TimeSheets?.response?.totalElements}
        handleChangePage={handlePageChange}
        handleRowsChange={handleRowsChange}
      />
    </div>
  );
};

export default Hoc(EmployeeDashboard);
